/**
 * Class joining. Deliberately not `tailwind-merge`: with a token system this
 * small, conflicting utilities are a mistake to fix rather than a runtime
 * problem to paper over.
 */
export type ClassValue = string | number | null | undefined | false | ClassValue[]

export function cn(...parts: ClassValue[]): string {
  const out: string[] = []
  for (const p of parts) {
    if (!p && p !== 0) continue
    if (Array.isArray(p)) { const s = cn(...p); if (s) out.push(s) }
    else out.push(String(p))
  }
  return out.join(' ')
}
